const Constants = {
  // This is the hardcoded PID for partner 0
  DEFAULT_PID: 'DEFAULT',
};

export default Constants;
